/**
 * 顶层节点
 */
export const TOP_LEVEL = 0;

export const WARNING_CODE_ROOT_CONFLICT = 1000;
export const WARNING_CODE_CHILD_CONFLICT = 1001;
